import { ICreateReservationFormValues } from '../../containers/Form/CreateReservation/CreateReservation'
import mapFormToRequest, { IRequestBody } from './mappers/mapValuesToRequest'
import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(
    calendarId: number,
    id: string,
    event: ICreateReservationFormValues,
  ) {
    const requestBody: IRequestBody = mapFormToRequest(calendarId, event, id)
    const response = await api.fetch(
      `/api/v2/reservation/update/id_reservation/${id}`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )

    if (response.ok) {
      return await handleResponse(response)
    } else {
      const resp = await response.json()
      const messages = resp.messages
      throw new Error(messages ? messages[0] : response.status.toString())
    }
  }
}
